import {SelectedFilters} from '../../../src/models/api/localPreferencesModel';
import {
  InboxesSearchLocationsEnum,
  RInboxesSearchLocation,
} from '../../../src/models/url/models/inboxesUrlModel';

/*
 * Const.
 */

export const selectedSearchFilterKey = 'search';

export const DEFAULT_SEARCH_FILTERS = [
  InboxesSearchLocationsEnum.LOCAL,
  InboxesSearchLocationsEnum.PINNED_IN_WORKSPACE,
  InboxesSearchLocationsEnum.GLOBAL,
] as const;

export const MOBILE_SEARCH_FILTERS = [
  InboxesSearchLocationsEnum.LOCAL,
  InboxesSearchLocationsEnum.GLOBAL,
] as const;

/*
 * Helpers.
 */

export function findSelectedInboxesSearchLocation(selectedFilters: SelectedFilters) {
  const selectedSearchFilter = selectedFilters[selectedSearchFilterKey];
  if (!selectedSearchFilter || !RInboxesSearchLocation.is(selectedSearchFilter)) {
    return InboxesSearchLocationsEnum.LOCAL;
  }

  return selectedSearchFilter;
}
